var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dsf-exam-layout", {
    attrs: { "exam-loading": _vm.examLoading },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "space-around" } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: _vm.examInfoData.manageName,
                          placement: "right",
                        },
                      },
                      [
                        _c("h3", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.examInfoData.manageName)),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("h3", { staticClass: "time" }),
                ]),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c(
                    "div",
                    { staticClass: "user" },
                    [
                      _vm._v(" " + _vm._s(_vm.examInfoData.examUserName) + " "),
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            "popper-class": "popper-user-info",
                            placement: "bottom-end",
                            trigger: "click",
                          },
                          on: { show: _vm.shwoUserInfo },
                        },
                        [
                          _c("dsf-view-part", {
                            attrs: { path: _vm.examInfoPath },
                          }),
                          _c("i", {
                            staticClass: "iconfont icon-bangzhuzhongxin",
                            attrs: { slot: "reference", title: "考试信息" },
                            slot: "reference",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "left",
        fn: function () {
          return [
            _c("p", { staticClass: "sub-title list bg pd-10" }, [
              _vm._v("答题卡"),
            ]),
            _c(
              "div",
              { staticClass: "card-list" },
              [
                _c(
                  "el-row",
                  { staticClass: "card-tips pd-10" },
                  [
                    _c("el-col", { staticClass: "a1", attrs: { span: 8 } }, [
                      _vm._v("已答：" + _vm._s(_vm.answeredCount)),
                    ]),
                    _c("el-col", { staticClass: "a2", attrs: { span: 8 } }, [
                      _vm._v(
                        "未答：" + _vm._s(_vm.speedLength - _vm.answeredCount)
                      ),
                    ]),
                    _c("el-col", { staticClass: "a3", attrs: { span: 8 } }, [
                      _vm._v("标记：" + _vm._s(_vm.markedCount)),
                    ]),
                  ],
                  1
                ),
                _vm._l(_vm.examInfoData.items, function (data) {
                  return [
                    data.name
                      ? _c(
                          "p",
                          {
                            key: "lefttitle_" + data.examPaperItemsId,
                            staticClass: "sub-title list pd-10",
                          },
                          [
                            _vm._v(" " + _vm._s(data.name)),
                            _c("span", { staticClass: "sub" }, [
                              _vm._v(
                                "（共" +
                                  _vm._s(data.totalNum) +
                                  "题，合计" +
                                  _vm._s(data.totalScore) +
                                  "分）"
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        key: data.examPaperId + data.examPaperItemsId,
                        staticClass: "question-list",
                      },
                      [
                        _vm._l(data.questions, function (q, i) {
                          return [
                            data.questionsItems.value != "group"
                              ? _c(
                                  "div",
                                  {
                                    key: "list_" + q.examQuestionsId,
                                    class: [
                                      "item",
                                      q.answered ? "answered" : "",
                                      q.marked ? "marked" : "",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.toScroll(q.examQuestionsId)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(++i) + " ")]
                                )
                              : _vm._l(q.children, function (childValue) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        key:
                                          "group_" + childValue.examQuestionsId,
                                        class: [
                                          "item",
                                          childValue.answered ? "answered" : "",
                                          childValue.marked ? "marked" : "",
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.toScroll(
                                              childValue.examQuestionsId,
                                              childValue.groupIndex - 1
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(childValue.groupIndex) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                }),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                }),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "main",
        fn: function () {
          return [
            _vm._l(_vm.examInfoData.items, function (data, index) {
              return [
                _c(
                  "p",
                  {
                    key: "subtitle_" + data.examPaperItemsId,
                    staticClass: "sub-title list bg pd-20",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.dsf.math.toChinesNum(++index) + "、" + data.name
                        ) +
                        " "
                    ),
                    data.totalScore
                      ? _c("span", { staticClass: "sub" }, [
                          _vm._v(
                            " （共" +
                              _vm._s(data.questions.length) +
                              "题，合计" +
                              _vm._s(data.totalScore) +
                              "分） "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  {
                    key: "content_" + data.examPaperItemsId,
                    staticClass: "exam-content",
                  },
                  _vm._l(data.questions, function (subjects, examIndex) {
                    return _c(
                      "div",
                      {
                        key: "question_" + subjects.examQuestionsId,
                        ref: "question" + subjects.examQuestionsId,
                        refInFor: true,
                      },
                      [
                        _c("dsf-exam-item-box", {
                          attrs: {
                            subjects: subjects,
                            "exam-index": examIndex,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "right",
        fn: function () {
          return [
            _c("div", { staticClass: "timer" }, [
              _c("p", { staticClass: "txt" }, [_vm._v("剩余时间")]),
              _c("p", { staticClass: "result-time" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.getTime.hours +
                        ":" +
                        _vm.getTime.minutes +
                        ":" +
                        _vm.getTime.seconds
                    ) +
                    " "
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "current-progress" },
              [
                _c("p", { staticClass: "txt" }, [_vm._v("当前进度")]),
                _c("el-progress", {
                  attrs: {
                    percentage: _vm.percentageNumber,
                    format: _vm.format,
                  },
                }),
              ],
              1
            ),
            _c("dsf-setting-font-size"),
            _vm.getAllowSubmit
              ? _c(
                  "el-button",
                  { staticClass: "exam-post", on: { click: _vm.submitPost } },
                  [_vm._v("提交试卷")]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }